import { Box, Flex, Icon, Toggle as NulogyToggle } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";

export default function LockToggle({ onChange, field: name }) {
  const { setFieldValue } = useFormikContext();
  const [field, _meta, helpers] = useField(name);

  const handleChange = (event) => {
    const { checked } = event.target;
    if (onChange) {
      onChange({ checked, setFieldValue });
    }
    helpers.setValue(checked);
  };

  return (
    <Flex alignItems="center" textAlign="right">
      <Box>
        <Icon color="darkBlue" icon={field.value ? "lock" : "unlock"} mr="x1" pt="4px" size="28px" />
      </Box>
      <Box>
        <NulogyToggle checked={field.value} className="pendo-lock-toggle spec-toggle-locked" onChange={handleChange} />
      </Box>
    </Flex>
  );
}
